<template>
    <div class="tracking-datetime">
        <p class="tracking-datetime__date">
            <span>
                {{ date }}
            </span>
            <span class="tracking-datetime__warning-container">
                <common-icon
                    v-if="!!icon && icon.name && icon.size"
                    :name="icon.name"
                    :size="icon.size"
                    :hintHeader="icon.hintHeader"
                    :hintText="icon.hintText"
                ></common-icon>
            </span>
        </p>

        <p class="tracking-datetime__time">
            {{ time }}
        </p>

        <p v-if="bottomText">
            {{ bottomText }}
        </p>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        props: {
            datetime: { type: String, required: true },
            icon: { type: Object, required: false, default: undefined },
            bottomText: { type: String, default: null },
        },

        computed: {
            date() {
                return dayjs(this.datetime).format('MMMM D, YYYY')
            },

            time() {
                return dayjs(this.datetime).format('hh:mm a')
            },
        },
    }
</script>
